import { METADATA_TYPE } from './accounts';
import { OptionItem } from './global';

export enum PACKAGE_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const PACKAGE_STATUSES: OptionItem[] = [
  {
    id: PACKAGE_STATUS.ACTIVE,
    name: 'Active',
  },
  {
    id: PACKAGE_STATUS.INACTIVE,
    name: 'Inactive',
  },
];

export interface PACKAGE_LIST_PARAMS_REQUEST {
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
}

export interface PACKAGE_TYPE {
  parent_rate: number;
  sitter_rate: number;
  price: number;
  id: string;
  name: string;
  description: string;
  is_active: boolean;
  is_read_only: boolean;
  tag: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface PACKAGE_LIST_STATE {
  records: PACKAGE_TYPE[];
  metadata: METADATA_TYPE;
  params?: PACKAGE_LIST_PARAMS_REQUEST | null | undefined;
}

export interface BODY_CREATE_PACKAGE {
  name: string;
  description: string;
  parent_rate: number;
  sitter_rate: number;
  price: number;
  tag: string;
}

export interface BODY_UPDATE_PACKAGE {
  name?: string;
  description?: string;
  parent_rate?: number;
  sitter_rate?: number;
  price?: number;
  tag?: string;
  status?: string;
}
